/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/QuickView/QuickView',[
    'jquery',
    'global/all',
    'global/UI/A11yRadioGroup',
    'modules/Product/Selections',
    'modules/Product/ProductAddToCart',
    'modules/Product/ProductImage',
    'modules/Product/ProductPrice',
    'modules/Product/ProductDetails',
    'modules/Product/UnitsOfMeasure',
    'modules/Product/ProductOutOfStockService',
    'modules/Upcharges/UpchargeService',
    'modules/Upcharges/UpchargeRegistrationService',
    'plugins/magnific-popup'
], function ($, Roc, RadioGroup, Selections, ProductAddToCart, ProductImage, ProductPrice, ProductDetails, UnitsOfMeasure, ProductOutOfStockService, UpchargeService, UpchargeRegistrationService) {
    'use strict';

    var apiUrl = window.RocConfig.api.baseRocApiUrl;
    var editItemCallback = null;
    var currentViewModel;

    function prepareViewModel(viewModel) {
        viewModel.outOfStockNotificationEmail = ProductOutOfStockService.getCurrentEmailAddress();

        UpchargeRegistrationService.preRenderQuickView(viewModel);

        // the product is available for pick up only if there's missing inventory in fulfillment center but "canAddProduct" flag set to true at the same time
        if (viewModel.product.productType !== 'Group'
            && viewModel.product.canAddProduct
            && viewModel.product.fulfillmentInventory
            && viewModel.product.fulfillmentInventory.qtyAvailable === 0
            && viewModel.product.fulfillmentInventory.inventoryAction !== 'BackOrder') {
            viewModel.limitedPickupStoreAvailability = true;
        } else {
            viewModel.limitedPickupStoreAvailability = false;
        }
        if (viewModel.product.unitsOfMeasure &&
            viewModel.product.unitsOfMeasure.selectedUomId &&
            viewModel.product.unitsOfMeasure.unitsOfMeasure) {
            var uom = _.find(viewModel.product.unitsOfMeasure.unitsOfMeasure, function (unit) {
                return unit.id === viewModel.product.unitsOfMeasure.selectedUomId;
            });

            if (uom) {
                viewModel.product.fulfillmentInventory.notEnough
                    = (uom.quantityInBaseUnit * viewModel.product.minInventoryQtyOutOfStockThreshold) >= viewModel.product.fulfillmentInventory.qtyAvailable;
            }
        }
        currentViewModel = viewModel;
    }

    function updateModalDisplay(viewModel) {
        prepareViewModel(viewModel);        
        
        Roc.UI.template('quickView-Tmp', viewModel).then(function (renderedTemplate) {
            showQuickView(renderedTemplate);
        });

        function showQuickView(renderedTemplate) {
            Roc.UI.Modal.open(renderedTemplate, {
                open: function () {                    
                    UpchargeRegistrationService.bindUpchargeEvents();
                    // check to see if product type is 'Group' and then set up selections
                    if (viewModel.product.productType === 'Group') {
                        Selections.init(apiUrl, viewModel.product.selectableAttributes);

                        // find selections container within the modal
                        var $selectionsContainer = $(this.content).find('.selections');

                        // bind click functionality on deselect triggers
                        $selectionsContainer.on('click', '[id^="deselect_"]', function (e) {
                            var attributeId = $(e.currentTarget).data('attributeId');
                            Selections.DeselectAttributeValue(attributeId);
                        });

                        // loop through each selectable attribute set
                        $selectionsContainer.find('.detailsRow').each(function (e) {
                            if ($(this).data('selectionType') === 'dropdown') {
                                // if it is a dropdown apply change event functionality
                                $('select', this).change(function (e) {
                                    var attributeId = $(e.currentTarget).attr('id');
                                    var unavailableOption = $("option:selected", this).hasClass('disabled');

                                    if ($(this).val().length === 0) {
                                        Selections.DeselectAttributeValue(attributeId);
                                    } else {
                                        Selections.SelectAttributeValue($(this).val(), unavailableOption);
                                    }
                                });
                            } else {
                                // if it is a swatch or other click-based selection set up functionality as required
                                var $selectionList = $('.selectionList', this);

                                // bind a11y enhancements to selection lists
                                new RadioGroup($selectionList.attr('id'));

                                $selectionList.on('rocDisabled', function (e) {
                                    var $currentActive = $(e.currentActive);

                                    Selections.UnavailableSelection($currentActive.attr('id'));
                                });

                                $selectionList.on('rocAfterActive', function (e) {
                                    var attributeId = $(e.delegateTarget).attr('id');
                                    var $currentActive = $(e.currentActive);
                                    var attributeValueId = $currentActive.attr('id');
                                    var unavailableOption = $currentActive.hasClass('disabled');

                                    Selections.SelectAttributeValue(attributeValueId, unavailableOption);
                                });
                            };
                        });
                    };

                },
                close: function () {
                    currentViewModel = null;
                }
            });
        };
    };

    function getProduct(id, options) {
        options = options || {};

        var product = $.ajax(apiUrl + '/api/product/' + id + '/');
        var productAttributes = $.ajax(apiUrl + '/api/product/' + id + '/selections/');

        Roc.UI.block();
        
        $.when(product, productAttributes).then(function (productModel, productAttributesModel) {
            var viewModel = {
                'product': productModel[0],
                'productId': id
            };

            viewModel.product.unitsOfMeasure = UnitsOfMeasure.getUnitsOfMeasureInfoForProduct(viewModel.product);
            viewModel.product.selectableAttributes = productAttributesModel[0];

            viewModel.options = {
                'action': options.action || Roc.Enums.quickViewAction.ADD_TO_CART,
                'buttonLabel': options.actionLabel,
                'initialQuantity': options.initialQuantity
            };

            // save group product id in order to keep group product context
            if (viewModel.product.productType === 'Group') {
                viewModel.groupContextId = viewModel.product.id;
            }

            editItemCallback = options.callback || null;

            Roc.UI.unblock();
            updateModalDisplay(viewModel);
        }, function () {
            Roc.UI.unblock();
            Roc.UI.displayErrorPopup("There was an error when loading product data");
        });
    };

    function renderQuickViewAddToCart(viewModel) {
        // reload 'add to cart' for quick view        
        Roc.UI.template('quickViewAddToCart-Tmp', viewModel).then(function (renderedTemplate) {
            $('#quickview-modal .itemCheckoutBox').html(renderedTemplate);
        });
    }

    function bindEvents() {
        Roc.UI.siteBody
            .off('click', '#qvEditItemBtn')
            .on('click', '#qvEditItemBtn', function (e) {
                e.preventDefault();
                try {
                    var request = ProductAddToCart.getValidatedRequestData('#qvEditItemBtn', '#updatedQuantity', Roc.Enums.quickViewAction.EDIT);
                    Roc.UI.Modal.close();
                    if (editItemCallback !== null && typeof editItemCallback === 'function') {
                        editItemCallback(request);
                    }
                } catch (error) {
                    Roc.UI.displayErrorPopup(error.msg, error.title);
                }
            });

        Roc.EventManager.bind(Roc.Events.products.SELECTIONS_UPDATE, function (productViewModel) {
            if (currentViewModel) {
                Roc.UI.block();
                currentViewModel.product = productViewModel;
                currentViewModel.product.unitsOfMeasure = UnitsOfMeasure.getUnitsOfMeasureInfoForProduct(currentViewModel.product);
                prepareViewModel(currentViewModel);
                renderQuickViewAddToCart(currentViewModel);
                Roc.UI.unblock();
            }
        });
    }

    function init() {
        ProductAddToCart.initForQuickView();
        ProductImage.init();
        ProductImage.initMainProductImage();
        ProductPrice.init();
        ProductDetails.init();
        UnitsOfMeasure.init();
        bindEvents();        
    };

    var QuickView = {
        init: init,
        getProduct: getProduct
    };

    Roc.Logger.debug('QuickView.js Loaded:', QuickView);

    init();

    return QuickView;
});

